module.exports = __webpack_public_path__ + "3ee4a1282848c8d94beb2ec1f50adc5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/logo_title_white.svg
// module id = 1700
// module chunks = 1